module.exports = __webpack_public_path__ + "static/img/decidoc-landing.235d8a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/decidoc-landing.png
// module id = 80
// module chunks = 0